import { render, staticRenderFns } from "./comp_CheckoutStep-recetadigital--done.vue?vue&type=template&id=4b4d2b70&scoped=true&"
import script from "./comp_CheckoutStep-recetadigital--done.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutStep-recetadigital--done.vue?vue&type=script&lang=js&"
import style0 from "./comp_CheckoutStep-recetadigital--done.vue?vue&type=style&index=0&id=4b4d2b70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4d2b70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VProgressCircular,VSpacer})
